import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconGoToLink = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.02947 4.5V5.99295L10.943 5.99824L4.50006 12.4412L5.55888 13.5L12.0018 7.05706L12.0071 12.9706L13.5001 12.9706L13.5001 4.5L5.02947 4.5Z",
		fill: "#707070"
	})
});
export default SvgIconGoToLink;
